import { useMemo, useRef } from 'react';
import { useRecoilValue   } from 'recoil';

import * as K from 'common/constants';
import { TOKEN_TYPE } from 'common/util/filter/types';

import Page from 'components/common/Page/Page';
import Sidebar from 'components/search/Sidebar/Sidebar';
import SearchToolbar from 'components/search/SearchToolbar';
import SidebarToggle from 'components/search/Sidebar/SidebarToggle';
import { settingsState } from 'components/common/Managers/SettingsManager.state';

import DistributionPageStateManager from './DistributionStateManager';
import DistributionGraphResultsToolbar from './DistributionGraphResultsToolbar';
import DistributionGraphResultsContainer from './DistributionGraphResultsContainer';

import './styles.scss';

function DistributionPage(): JSX.Element {
  const settings = useRecoilValue(settingsState);
  const sidebarToggleRef = useRef(null);

  const excludeTypes = useMemo(() => [ TOKEN_TYPE.COMMAND ], []);

  return (
    <Page docTitle="Graph" type="full">
      <SearchToolbar excludeTypes={excludeTypes} />
      <div className="DistributionPage__ResultsArea">
        <div className="DistributionPage__SidebarContainer">
          {settings[K.SETTING.SHOW_SIDEBAR] &&  <Sidebar mode={K.EVENT_MODE.GRAPH} />}
          <SidebarToggle toggleRef={sidebarToggleRef} />
        </div>
        <div className="DistributionPage__ResultsContainer">
          <DistributionGraphResultsToolbar />
          <div className="DistributionPage__GraphContainer">
            <DistributionGraphResultsContainer />
          </div>
        </div>
      </div>
      <DistributionPageStateManager />
    </Page>
  );
}

export default DistributionPage;
